module.exports = __webpack_public_path__ + "img/yule.4ad3ca9e.png";